var map = {
	"./style-attachment-list-active.svg": "bcd9",
	"./style-attachment-list.svg": "7Bcl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JcA+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/style\-attachment\-list.*\.svg$
// module id = JcA+
// module chunks = 46